/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import Vue from 'vue'

import { FETCH_DASHBOARD_ORDERS } from '../../actions.type'
import {
  SET_DASHBOARD_ORDERS_COUNT,
  SET_DASHBOARD_ORDERS_REQUEST,
  SET_DASHBOARD_ORDERS_VALUE
} from '../../mutations.type'

const state = {
  orders: {
    request: {
      isLoading: undefined,
      isSuccess: undefined,
      isError: undefined,
      isFatalError: undefined,
      delay: undefined,
      lastRequestTime: undefined,
      params: {
        dateStart: null,
        dateEnd: null,
        itemsPerPage: -1,
        page: 1,
        sortBy: [],
        sortDesc: []
      }
    },
    value: [],
    count: 0
  }
}

const getters = {
  dashboardOrdersRequest: (state) => state.orders.request,
  dashboardOrdersValue: (state) => state.orders.value,
  dashboardOrdersCount: (state) => state.orders.count,
  dashboardOrdersById: (state) => {
    const result = {}
    state.orders.value.forEach((order) => {
      result[order.id] = order
    })
    return result
  }
}

const actions = {
  async [FETCH_DASHBOARD_ORDERS]({ commit, state }, params) {
    if (
      (state.orders.request.isSuccess && !params?.isReload) ||
      state.orders.request.isLoading ||
      state.orders.request.isError
    ) {
      return
    }

    // Сброс состояния при перезагрузке
    if (params?.isReload) {
      commit(SET_DASHBOARD_ORDERS_REQUEST, {
        isSuccess: false,
        isError: false
      })
    }

    try {
      const {
        data: { items, count }
      } = await Vue.axios.get('order/dashboard', {
        headers: {
          ...(params.itemsPerPage && { 'Items-Per-Page': params.itemsPerPage }),
          ...(params.page && { Page: params.page }),
          ...(params.sortBy && { 'Sort-By': params.sortBy }),
          ...(params.sortDesc && { 'Sort-Desc': params.sortDesc }),
          ...(params.where && { Where: params.where })
        },
        'axios-retry': {
          beforeTry: () => {
            commit(SET_DASHBOARD_ORDERS_REQUEST, {
              isLoading: true,
              isError: false
            })
          },
          afterTry: ({ delay, lastRequestTime }) => {
            commit(SET_DASHBOARD_ORDERS_REQUEST, {
              isLoading: false,
              isError: true,
              delay,
              lastRequestTime
            })
          }
        }
      })
      commit(SET_DASHBOARD_ORDERS_REQUEST, {
        isLoading: false,
        isSuccess: true
      })
      commit(SET_DASHBOARD_ORDERS_VALUE, items)
      commit(SET_DASHBOARD_ORDERS_COUNT, count)
    } catch (e) {
      commit(SET_DASHBOARD_ORDERS_REQUEST, {
        isFatalError: true
      })
    }
  }
}

const mutations = {
  [SET_DASHBOARD_ORDERS_REQUEST](state, request) {
    state.orders.request = {
      ...state.orders.request,
      ...request
    }
  },
  [SET_DASHBOARD_ORDERS_VALUE](state, value) {
    state.orders.value = value
  },
  [SET_DASHBOARD_ORDERS_COUNT](state, count) {
    state.orders.count = count
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
